import { useId } from "react";

import { Text } from "../../../../core/Text.js";
import { PullRow } from "../../../shared/PullRow.js";
import type { TopHitsContent } from "../../boxesContent.js";

/** The shopper's best pulls, each opening its details; nothing for none. */
export function BoxesTopHits({ title, opens }: TopHitsContent) {
  const id = useId();
  if (opens.length === 0) return null;
  return (
    <section aria-labelledby={id} className="flex flex-col gap-4">
      <Text as="h2" id={id} variant="display-xl4" tone="primary">
        {title}
      </Text>
      <PullRow opens={opens} />
    </section>
  );
}
